module.exports = __webpack_public_path__ + "static/assets/5cbe857a07cdefccea566089e71a7053.png";